// extracted by mini-css-extract-plugin
export default {"touchArea":"style-module--touchArea--BOem5"};